module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSIjQjQxQjNFIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMTg0OCAxMi4zOTk5VjMuMzk5OUgxMS4yMzc3VjEyLjM5OTlIMTMuMTg0OFpNOS4yOTA1NiAxMi4zOTk5VjYuMjEyNEg3LjM0MzQ1VjEyLjM5OTlIOS4yOTA1NlpNNS4zOTYzMyAxMi4zOTk5VjkuMDI0OUgzLjQ0OTIyVjEyLjM5OTlINS4zOTYzM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_hub_bi.svg
// module id = 1ylu
// module chunks = 1